import React, { useState } from "react";
import axios from "axios";
import "./SurveyEditPanel.css";

export default function SurveyEditPanel({ survey, companyId, onSaved }) {

     

  const [expiresAt, setExpiresAt] = useState(survey.expires_at || "");
  const [status, setStatus] = useState(survey.status);
  const [expected, setExpected] = useState(survey.response_expected || "");
  const [saving, setSaving] = useState(false);

  const saveChanges = async () => {

    if (!expected || expected <= 0) {
      alert("Responses expected must be greater than 0");
      return;
    }

    try {
      setSaving(true);
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/superadmin/survey/update`,
        {
          surveyId: survey.survey_id,
          companyId: companyId,
          expires_at: expiresAt || null,
          status,
          responses_expected: expected
        }
      );

      alert("Survey updated");
      onSaved();
    } catch (err) {
      console.error(err);
      alert("Failed to save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="survey-edit-panel">
      <h3>✏ Edit Survey</h3>

      <div className="field">
        <label>Status</label>
<div className="custom-select">
  <select value={status} onChange={(e) => setStatus(e.target.value)}>
    <option value="active">Active</option>
    <option value="inactive">Inactive</option>
    <option value="expired">Expired</option>
  </select>
</div>

      </div>

      <div className="field">
        <label>Expires At</label>
        <input
          type="date"
          value={expiresAt?.slice(0, 10)}
          onChange={(e) => setExpiresAt(e.target.value)}
        />
      </div>

      <div className="field">
        <label>Responses Expected</label>
        <input
          type="number"
          min="1"
          value={expected}
          onChange={(e) => setExpected(e.target.value)}
        />
      </div>

       <button  onClick={saveChanges} disabled={saving} className="save-btn">
    💾  {saving ? "Saving..." : "Save Changes"}
  </button>


    </div>
  );
}
